import { Grid } from '@/common/grid/Grid';
import { useDependentKey } from '@/common/hooks/key/useDependentKey';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useRef, useState } from 'react';

export const ChbkFinTrendTable = ({ formValues, totalValues, ctrtTypeIdToCtrtType, byYear, dim }) => {

  let { invPeriodId, invDate, distCustIds, ctrtTypeIds, prodIds, agg } = formValues;

  const { totalProdIds, totalDistCustIds } = totalValues;

  const gridRef = useRef();

  const rsrc = useRsrc();

  const [data, setData] = useState();

  const [fieldDefs, setFieldDefs] = useState();
  const [isGridReady, setIsGridReady] = useState(false);

  useEffect(() => {
    setIsGridReady(false);

    const reqParam = {
        periodId: invPeriodId,
        invDate,
        byYear,
        agg
    };

    rsrc.data('sc', 'CHBK_FIN_TREND_TABLE_FIELD_DEFS_DATA_PLUGIN', reqParam).then(fieldDefs => {
      setFieldDefs(fieldDefs);
    });
  }, [invPeriodId, invDate, byYear, agg]);

  useEffect(() => {
    if (!invPeriodId && !invDate) {
      return;
    }

    let prodIdsNot = true;
    if (totalProdIds.length / 2 < prodIds.length) {
      prodIds = totalProdIds.filter(id => !prodIds.includes(id));
    } else {
      prodIdsNot = false;
    }

    let distCustIdsNot = true;
    if (totalDistCustIds.length / 2 < distCustIds.length) {
      distCustIds = totalDistCustIds.filter(id => !distCustIds.includes(id));
    } else {
      distCustIdsNot = false;
    }

    const reqParam = {
      periodId: invPeriodId,
      invDate,
      distCustIds,
      distCustIdsNot,
      ctrtTypes: ctrtTypeIds.map(id => ctrtTypeIdToCtrtType[id]),
      prodIds,
      prodIdsNot,
      byYear,
      agg,
      dim
    };

    rsrc.data('sc', 'CHBK_FIN_TREND_TABLE_DATA_PLUGIN', reqParam).then(res => {
      setData(res);
    });

  }, [invPeriodId, invDate, distCustIds, ctrtTypeIds, prodIds, byYear, agg, dim]);

  const onGridReady = () => {
    setIsGridReady(true);
  };

  useEffect(() => {
    if (isGridReady && gridRef.current && data) {
        gridRef.current.setDataSource(data.rows);
        gridRef.current.setTotalsRow(data.totalsRow);
    }
  }, [isGridReady, data]);

  const gridKey = useDependentKey(fieldDefs);

  if (!data) {
    return null;
  }

  return (
    <>
        <Grid
            key={gridKey}
            ref={gridRef}
            gridOptions={{
            fieldDefs,
            rowModelType: 'clientSide',
            statusBar: null
            }}
            events={{ onGridReady }}
        />
    </>

  );
};
